import { SafeAreaInsets } from '@/types/global';
import { inquiryCommentTemplateInitial } from '@/types/inquiry';
import { atom } from 'recoil';

export const templateInquiryState = atom({
  key: 'templateInquiryState',
  default: inquiryCommentTemplateInitial,
});

/** V3 */
export const safeAreaInsetsState = atom<SafeAreaInsets>({
  key: 'safeAreaInsetsState',
  default: {
    topInset: 0,
    bottomInset: 0,
  },
});

export const gameCategoryState = atom({
  key: 'gameCategoryState',
  default: '전체',
});

export const gameScoreState = atom({
  key: 'gameScoreState',
  default: '0',
});

export const recentSearchKeywordListAsyncStorageState = atom<Array<string>>({
  key: 'recentSearchKeywordListAsyncStorageState',
  default: [],
});

// 모바일 기기 여부 (우선 chatbot에서만 사용)
export const isMobileState = atom<boolean>({
  key: 'isMobileState',
  default: false,
});

//AiChatBot 초기 질문 상태(query)
export const initialRequestState = atom<string>({
  key: 'initialRequestState',
  default: '',
});

// AiChatBot 세션 아이디
export const aiChatBotSessionIdState = atom<string>({
  key: 'aiChatBotSessionIdState',
  default: '',
});

export const deviceUuidState = atom<string>({
  key: 'deviceUuidState',
  default: '',
});

export const isDirectSubmitAnswerState = atom<boolean>({
  key: 'isDirectSubmitAnswerState',
  default: false,
});

export const isDirectSubmitAnswerInquiryState = atom<boolean>({
  key: 'isDirectSubmitAnswerInquiryState',
  default: false,
});

export const initialOrderState = atom({
  key: 'initialOrderState',
  default: { findMarket: '', findMarketName: '' },
});
